import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '@repo/ui';

interface SuccessStepProps {
  onSuccess?: () => void;
  onBack?: () => void;
}

export const SuccessStep: React.FC<SuccessStepProps> = ({ onSuccess, onBack }) => {
  const { t } = useTranslation();

  return (
    <div className="text-center py-8">
      <div className="w-24 h-24 bg-linear-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-8 shadow-xl shadow-green-500/30">
        <CheckCircle2 className="h-12 w-12 text-white" />
      </div>

      <Button
        onClick={onSuccess || onBack}
        className="w-full p bg-[oklch(0.34_0.17_262.91)] hover:bg-[oklch(0.34_0.17_262.91)]/90 text-white shadow-lg shadow-[oklch(0.34_0.17_262.91)]/20 cursor-pointer"
        size="sm"
      >
        {t('auth.signInNow')}
      </Button>
    </div>
  );
};
